var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18.013 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nightIcon",
    transform: "translate(-222.515 27.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M237.014-16.376a8.809,8.809,0,0,0,2.65-.479.608.608,0,0,1,.692.13.6.6,0,0,1,.11.694,9,9,0,0,1-7.06,5.907A9.157,9.157,0,0,1,223.4-15.292a8.686,8.686,0,0,1-.8-5.017,9.088,9.088,0,0,1,5.974-7.59.609.609,0,0,1,.711.1.627.627,0,0,1,.124.71,8.043,8.043,0,0,0,6.137,10.539C236.028-16.453,236.524-16.431,237.014-16.376Z",
    transform: "translate(0 0)",
    fill: "#3f85bb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightIcon);
export default __webpack_public_path__ + "static/media/nightIcon.4f8e2a02f4d97ba83c7f6967fee5aff2.svg";
export { ForwardRef as ReactComponent };